<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h1 class="titlePage titlePage_textLeft">{{getUserName}}</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <h2 class="titlePage_subtitle titlePage ">Product Summary</h2>

        <div class="row align-items-start">

          <div class="col-12" v-if="!items.locations">
            <p class="text text_italic text_green">No location added yet</p>
          </div>

          <div class="col-md-4 col-sm-6 col-12"
               v-for="(item, index) in locationListCreate()"
               :key="index">
            <div class="orderItem">

              <div class="orderItem__listItems">
                <h3 class="orderItem__listTitle text_green text_center">{{item.name}}</h3>

                <div class="toggleList"
                     v-for="(elem, key) in item.items.standard"
                     :key="key">
                  <img :src="elem.icon"
                       :alt="elem.name"
                       class="orderItem__img">
                  <h5 class="toggleList__title">
                    <span v-if="elem.custom" class="text_red text_bold">Custom</span>
                    <span v-else>{{elem.width}} x {{elem.drop}}</span>
                    {{elem.name}}
                    <span v-if="elem.custom" class="text_red"> - *Call for a quote</span>
                    <span class="text_green toggleList__trigger"
                          v-if="counter(elem.accessories)"
                          @click="openAccessories($event)">
                        +{{counter(elem.accessories)}} accessories
                      </span>
                  </h5>

                  <ul class="toggleList__wrap">
                    <li class="toggleList__item"
                        v-for="accessory in elem.accessories">{{accessory.name}}
                    </li>
                  </ul>
                </div>

                <div class="orderItem__price">
                  <span class="" v-if="item.items.standard">aud ${{calcPrice(Number(item.amount).toFixed(2))}}</span>
                </div>
              </div>
              <div class="orderItem__divider" v-if="item.items.custom"></div>
              <div class="orderItem__listItems" v-if="item.items.custom">

                <h3 class="orderItem__listTitle text_red text_center">Custom</h3>

                <div class="toggleList"
                     v-for="(elem, key) in item.items.custom"
                     :key="key">

                  <img :src="elem.icon"
                       :alt="elem.name"
                       class="orderItem__img">
                  <h5 class="toggleList__title">
                    <span v-if="elem.custom" class="text_red text_bold">Custom</span>
                    <span v-else>{{elem.width}} x {{elem.drop}}</span>
                    {{elem.name}}
                    <span v-if="elem.custom" class="text_red"> - *Call for a quote</span>
                    <span class="text_green toggleList__trigger"
                          v-if="counter(elem.accessories)"
                          @click="openAccessories($event)">
                        +{{counter(elem.accessories)}} accessories
                      </span>
                  </h5>

                  <ul class="toggleList__wrap">
                    <li class="toggleList__item"
                        v-for="accessory in elem.accessories">{{accessory.name}}
                    </li>
                  </ul>
                </div>

                <div class="orderItem__price">
                  <span class="text_red text_bold">Call for a quote</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <order-summary/>
    </div>

    <div class="row">
      <div class="col">
        <router-link
          :to="{name: 'dashboard'}"
          tag="span"
          class="btn btn_default"
        >
          Back to dashboard
        </router-link>
      </div>
    </div>

  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import router from "../../router";
  import {changePriceForm} from '../../helpers/aroundPrice';

  export default {
    name: "OrderPreview",

    components: {
      OrderSummary: () => import("./orderSummaryTable/OrderSummary"),
    },

    data() {
      return {
        exchangeData: '',
        currentRouteName: '',
        accessoriesListCount: '',
        editAccessoryData: '',
        editAccessory: false,
      }
    },

    methods: {
      setRoute() {
        this.currentRouteName = this.$router.currentRoute.name;
      },

      openAccessories(e) {
        let target = e.target;
        if (target.closest('.accessories_count')) {
          let items = target.closest('.accessories_count').querySelectorAll('.additional__wrap');
          for (let i = 0; i < items.length; i++) {
            items[i].classList.toggle('toggleList_open');
            items[i].classList.toggle('additional__wrap_open');
          }
        }
        else {
          target.closest('.toggleList').classList.toggle('toggleList_open');
        }
      },

      counter(elem) {
        if (!elem) {
          return false;
        }
        return _.toInteger(Object.keys(elem).length);
      },

      locationListCreate() {
        if (!this.items.locations) return;
        return _.filter(this.items.locations, function (location) {
          if (location.name !== "Accessories") return location
        });
      },

      checkCustom(elem) {
        let custom = false;
        for (let k in elem.items) {
          if (k === 'custom') {
            return custom = true;
          }
        }
      },
      calcPrice(price) {return changePriceForm(price);}

    },

    computed: {
      ...mapGetters({
        items: 'orderPreview/items',
      }),

      getUserName() {
        return localStorage.getItem('nameUser');
      },
    },

    created() {
      this.setRoute();
      this.$store.commit('orderPreview/id', this.$route.params.id);
      return this.$store.dispatch('orderPreview/getPreview');
    },
  }
</script>

<style scoped lang="scss">
  .thumbnailsTable{
    cursor: pointer;
  }
</style>
